import { AxiosError } from 'axios';

import { ERRORS_MSG } from '../constants/errorsMsg';
import { NotificationsStore } from '../store/notifications';

export const handleServiceError = (error: unknown) => {
  throw error;
};

type logErrorOptions = {
  prefix?: string;
  details?: string;
};

export function logError(error: unknown, { prefix, details }: logErrorOptions = {}) {
  if (error instanceof Error && 'issues' in error) {
    // eslint-disable-next-line no-console
    console.error(...[prefix, error.issues].filter(Boolean));
  } else {
    // eslint-disable-next-line no-console
    console.error(...[prefix, error].filter(Boolean));
  }

  if (typeof details !== 'undefined') {
    // eslint-disable-next-line no-console
    console.debug(details);
  }
}

export const logAndNotifyError = (prefix: string, error: unknown, shouldDisplayErrorAlert = true) => {
  const isACancelledCall = (error as AxiosError)?.code === 'ERR_CANCELED';
  if (isACancelledCall) {
    return null;
  }

  logError(error, { prefix });

  if (shouldDisplayErrorAlert) {
    const errorTitle = ERRORS_MSG[(error as AxiosError)?.code as keyof typeof ERRORS_MSG] ?? 'common.error.default';

    NotificationsStore.getState().pushAlert({
      type: 'error',
      title: errorTitle,
      duration: 5000,
      id: 'default-error',
    });
  }

  return error;
};

export const isErrorCanceled = (error?: unknown) => (error as AxiosError)?.code === 'ERR_CANCELED';
